import React from 'react';
import { Link } from 'react-router-dom';
import AdminSignInPrompt from './AdminSignInPrompt';
import Alert from '../ui/Alert';
import Button from '../ui/Button';
import { auth, firebaseSignOut } from '../../auth';

/**
 * Shared post-timeout / signed-out gate for admin pages.
 */
export default function AdminAuthGate({ title, authTimedOut }) {
  if (!authTimedOut) {
    return <AdminSignInPrompt title={title} />;
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-4">
        <h1 className="text-xl font-black">{title}</h1>
        <Alert tone="warning" className="text-sm font-bold">
          Could not initialize admin sign-in. Refresh or sign in again.
        </Alert>
        <Button type="button" variant="admin" onClick={() => window.location.reload()}>
          Refresh
        </Button>
        <Button
          type="button"
          variant="ghost"
          onClick={() => firebaseSignOut(auth).catch(() => {})}
        >
          Sign out
        </Button>
        <p className="text-xs text-gray-500">
          <Link to="/" className="text-violet-400 hover:text-violet-300">Back to home</Link>
        </p>
      </div>
    </div>
  );
}
